/**
 * Testing-only OTP autofill control.
 * Displays when the backend returns `devCode` (same value SES emailed).
 * Can be explicitly disabled by setting REACT_APP_EXPOSE_OTP_FILL=false.
 */
export function showDevOtpFill(devCode) {
  if (!devCode) return false;
  if (process.env.REACT_APP_EXPOSE_OTP_FILL === "false") return false;
  return true;
}

export function captureOtpFill(
  expectedAudience,
  location = globalThis.location,
  history = globalThis.history,
) {
  const rawHash = String(location?.hash || "").replace(/^#/, "");
  const rawSearch = String(location?.search || "").replace(/^\?/, "");

  let source = "hash";
  let parameters = new URLSearchParams(rawHash);
  if (!parameters.get("otp_code")) {
    const searchParams = new URLSearchParams(rawSearch);
    if (searchParams.get("otp_code")) {
      parameters = searchParams;
      source = "search";
    }
  }

  const email = String(parameters.get("otp_email") || "")
    .trim()
    .toLowerCase();
  const code = String(parameters.get("otp_code") || "");
  const audience = parameters.get("otp_audience") || "";
  const expiresAt = Date.parse(parameters.get("otp_expires") || "");

  const audienceMatches =
    audience === expectedAudience ||
    (expectedAudience === "user" &&
      ["user", "client", "photographer", "guest"].includes(audience));

  if (!audienceMatches || !email || !/^\d{6,8}$/.test(code)) {
    return null;
  }

  for (const key of ["otp_email", "otp_code", "otp_audience", "otp_expires"]) {
    parameters.delete(key);
  }

  if (source === "hash") {
    const nextHash = parameters.toString();
    history?.replaceState?.(
      history.state,
      "",
      `${location.pathname || "/"}${location.search || ""}${
        nextHash ? `#${nextHash}` : ""
      }`,
    );
  } else {
    const nextSearch = parameters.toString();
    history?.replaceState?.(
      history.state,
      "",
      `${location.pathname || "/"}${
        nextSearch ? `?${nextSearch}` : ""
      }${location.hash || ""}`,
    );
  }

  return {
    email,
    code,
    expiresAt: Number.isFinite(expiresAt) ? expiresAt : 0,
  };
}
